import { Box, Typography } from "@mui/material";
import React from "react";
import AppFooter from "../../components/footer";
import NavBar from "../../components/NavBar";
import { t } from "i18next";

const ComingSoon = () => {
  return (
    <>
      <NavBar />
      <Box
        mt={"40px"}
        height={"80vh"}
        bgcolor={"primary.main"}
        sx={{
          backgroundImage: `url("https://service-provider-2024.s3.us-east-1.amazonaws.com/uploads/1744561279073_without%20text%20%281%29.jpg")`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h3"
          fontWeight={"bold"}
          color="white"
          textTransform={"capitalize"}
        >
          {t("mobileApp")}
        </Typography>
        <Typography variant="h5" fontWeight={"bold"} color="white">
          {t('comingSoon')}....
        </Typography>
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default ComingSoon;
